"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeTemplateType = exports.serializeTemplateType = void 0;
const core_1 = require("../../core");
const template_1 = require("./template");
const serializeTemplateType = (templateType) => templateType.toString();
exports.serializeTemplateType = serializeTemplateType;
const deserializeTemplateType = (templateTypeStr) => {
    switch (templateTypeStr) {
        case 'HTML':
            return template_1.TemplateType.HTML;
        case 'JSON':
            return template_1.TemplateType.JSON;
        case 'CSV':
            return template_1.TemplateType.CSV;
        case 'MARKDOWN':
            return template_1.TemplateType.Markdown;
        case 'FILE_PATH':
            return template_1.TemplateType.FilePath;
        default:
            throw new core_1.BadTemplateTypeError(`Unsupported TemplateType '${templateTypeStr}'. Allowed values are ${Object.values(template_1.TemplateType).join(', ')}`);
    }
};
exports.deserializeTemplateType = deserializeTemplateType;
//# sourceMappingURL=serdes.js.map